import React from 'react';
import StringInput from './StringInput';
import NumberInput from './NumberInput';
import BooleanInput from './BooleanInput';
import DateInput from './DateInput';
import ArrayInput from './ArrayInput';
import { DataType } from '../types';

type Props = {
  onBlur: Function,
  onChange: Function,
  value: any,
  dataType: DataType,
  placeholder: string,
  selectOptions?: Array<string | number>,
};

export default function BQArgumentsInputRenderer(props: Props) {
  const {
    onBlur,
    onChange,
    value,
    dataType,
    selectOptions,
    placeholder,
  } = props;
  switch (dataType) {
    case 'STRING':
      return (
        <StringInput
          placeholder={placeholder}
          value={value}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
    case 'INT64':
    case 'FLOAT64':
      return (
        <NumberInput
          isFloat={dataType === 'FLOAT64'}
          placeholder={placeholder}
          value={value}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
    case 'BOOL':
      return <BooleanInput value={value} onBlur={onBlur} onChange={onChange} />;
    case 'DATE':
      return <DateInput value={value} onBlur={onBlur} onChange={onChange} />;
    case 'ARRAY<INT64>':
    case 'ARRAY<STRING>':
    case 'ARRAY<FLOAT64>':
      return (
        <ArrayInput
          isFloat={dataType === 'ARRAY<FLOAT64>'}
          placeholder={placeholder}
          selectOptions={selectOptions || []}
          type={
            ['ARRAY<INT64>', 'ARRAY<FLOAT64>'].includes(dataType)
              ? 'number'
              : 'string'
          }
          value={value}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
    case 'ARRAY<BOOL>':
      return (
        <ArrayInput
          placeholder={placeholder}
          selectOptions={['true', 'false']}
          type="boolean"
          value={value}
          onBlur={onBlur}
          onChange={onChange}
        />
      );
    default:
      return null;
  }
}
